<template>
  <div class="order-page">
    <div class="card-panel mb16">
      <div class="tabs-filter">
        <Search ref="unpaidSearchForm" @getList="getList" pageEntry="unpaid" />
      </div>
    </div>
    <div class="card-panel">
      <z-table
        v-loading="loading"
        ref="table"
        :data="orderList"
        :columns="columns"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
      >
        <template v-slot:orderNo="{ row }">
          <p>
            <span class="item-orderNo">{{ row.orderNo }}</span>
            <el-tooltip class="item" effect="dark" content="复制订单编号" placement="top">
              <i class="iconfont iconcopy" @click.stop="() => handleCopy(row.orderNo)"></i>
            </el-tooltip>
            <span v-if="row.riskStatus" style="color: red">风险订单</span>
          </p>
        </template>
        <template v-slot:shipmentStatus="{ row }">
          {{ row.shipmentStatus ? row.shipmentStatus : '-' }}
        </template>
        <template v-slot:payTotalAmount="{ row }">{{ row.symbol || '' }}{{ row.payTotalAmount }}</template>
        <template v-slot:paidMultiplied="{ row }">
          <p>{{ row.paidMultiplied === true ? '是' : '否' }}</p>
        </template>
        <template v-slot:spuCodes="{ row }">
          <p v-if="row.spuCodes && row.spuCodes.length === 1">{{ row.spuCodes[0] }}</p>
          <p v-else-if="row.spuCodes && row.spuCodes.length > 0">
            <el-tooltip effect="dark" :content="row.spuCodes.join('，')" placement="top">
              <span>{{ row.spuCodes[0] }}...</span>
            </el-tooltip>
          </p>
          <p v-else>-</p>
        </template>
      </z-table>
    </div>
  </div>
</template>
<script>
import { queryType, queryTimeType, orderListColumns } from '../config/index'
import { getOrderList } from '@/server/order'
import Search from '../components/search'
import { _local, setSession } from '@/utils/storage'
// import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UnPaid',
  components: { Search },
  data () {
    return {
      queryType,
      queryTimeType,
      orderList: [],
      columns: orderListColumns,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      loading: false
    }
  },
  computed: {
    queryTypeHolder () {
      return this.queryType.find(item => item.value === this.curQueryType).placeholder
    }
  },
  async mounted () {
    const searchData = this.$refs.unpaidSearchForm.getSearchParams()
    this.getList(searchData, true)
  },
  methods: {
    handleTabClick () {
      const searchData = this.$refs.unpaidSearchForm.getSearchParams()
      this.getList(searchData, true)
    },
    getParams () {
      const data = {
        ordersType: 'NON',
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      }
      return data
    },
    async getList (searchParams, init = false) {
      if (init) {
        // 回到第一页
        this.pagination.pageNum = 1
      }

      this.loading = true
      const params = this.getParams()
      // console.log('{...params, ...searchParams}:', {...params, ...searchParams})
      const { data } = await getOrderList({ ...params, ...searchParams })
      console.log(data)
      if (data.code === this.$code) {
        this.orderList = data.data.items
        this.pagination.total = data.data.totalCount ? data.data.totalCount : 0
      }
      this.loading = false
    },
    handleRow (row) {
      _local.set(
        'orderNumberList',
        this.orderList.map(item => item.orderNo)
      )
      setSession('backUrl', '/unpaidOrder')
      this.$router.push(`orderDetail/${row.orderNo}`)
    },
    handlePageChange () {
      const searchData = this.$refs.unpaidSearchForm.getSearchParams()
      this.getList(searchData, false)
    },
    handleCopy (orderNo) {
      const _this = this
      this.$copyText(orderNo).then(
        function (e) {
          _this.$message.success(this.$t('system::tip::copy_success'))
        },
        function (e) {

        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.ml16 {
  margin-left: 16px;
}
.mt16 {
  margin-top: 16px;
}
.mb16 {
  margin-bottom: 16px;
}

.order-page {
  min-width: 970px;
  .card-panel {
    box-sizing: border-box;
    background: #fff;
    border-radius: 5px;
    padding: 16px;
    padding-bottom: 4px;
  }
}
.item-orderNo {
  display: inline-block;
  width: 160px;
}
i.iconcopy {
  cursor: pointer;
}
</style>
